import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const About = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      id="about" 
      data-testid="about-section"
      className="section-padding bg-primary-bg"
      ref={ref}
    >
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-[4/5] overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_build-website-154/artifacts/jomz8ctt_about01.jpg"
                alt="Brett Rimmer on construction site"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Accent box */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 border border-accent/30 hidden lg:block" />
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <p className="overline mb-4">About Rimsie</p>
            <h2 
              data-testid="about-heading"
              className="text-4xl sm:text-5xl font-heading font-light text-heading mb-8"
            >
              The Builder Behind<br />the Construction
            </h2>
            
            <div className="space-y-6 text-body-text leading-relaxed">
              <p>
                Brett Rimmer has been building on the Central Coast for over two decades. 
                As director of Rimsie Constructions Pty Ltd, Brett runs every project hands-on. 
                He coordinates all trades, manages the timeline, and stays on site. 
                You deal with Brett directly, start to finish.
              </p>
              <p>
                From a full commercial hotel renovation to a residential new build in your street, 
                the approach is the same. Tight organisation. Trusted trades. No surprises.
              </p>
            </div>

            <div className="mt-10 pt-8 border-t border-border-subtle flex flex-wrap gap-8">
              <div>
                <p className="text-accent text-sm font-semibold mb-1">Licence</p>
                <p className="text-heading text-lg">359294C</p>
              </div>
              <div>
                <p className="text-accent text-sm font-semibold mb-1">Location</p>
                <p className="text-heading text-lg">Tuggerah, NSW</p>
              </div>
              <div>
                <p className="text-accent text-sm font-semibold mb-1">Experience</p>
                <p className="text-heading text-lg">20+ Years</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
